export default __webpack_public_path__ + "img/0f6ede17e15301540c07a3d5776fba3e.svg";